export { default as TerritoryPanel } from './TerritoryPanel';
